export default function calculateSalesPrice(salesPrice, salesPriceQuantity, decimals) {
  const calculated = salesPrice / salesPriceQuantity;

  return calculated.toFixed(decimals);
}
